import { css } from '@emotion/react'

const showMore = css`
  padding: 5px;
  padding-right: 10px;
  font-size: 0.7692307692307693rem;
  font-weight: 500;
  text-align: right;
  min-height: 11px;
  color: #7e8f9f !important;

  & > a {
    color: #7e8f9f !important;
    cursor: pointer;
  }
`

export const styles = {
  showMore,
}
